import { render, staticRenderFns } from "./Solution.vue?vue&type=template&id=45f44eaf&scoped=true"
import script from "./Solution.vue?vue&type=script&lang=js"
export * from "./Solution.vue?vue&type=script&lang=js"
import style0 from "./Solution.vue?vue&type=style&index=0&id=45f44eaf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f44eaf",
  null
  
)

export default component.exports